function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classPrivateMethodInitSpec(obj, privateSet) { _checkPrivateRedeclaration(obj, privateSet); privateSet.add(obj); }
function _classPrivateFieldInitSpec(obj, privateMap, value) { _checkPrivateRedeclaration(obj, privateMap); privateMap.set(obj, value); }
function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }
function _classPrivateFieldGet(receiver, privateMap) { var descriptor = _classExtractFieldDescriptor(receiver, privateMap, "get"); return _classApplyDescriptorGet(receiver, descriptor); }
function _classApplyDescriptorGet(receiver, descriptor) { if (descriptor.get) { return descriptor.get.call(receiver); } return descriptor.value; }
function _classPrivateFieldSet(receiver, privateMap, value) { var descriptor = _classExtractFieldDescriptor(receiver, privateMap, "set"); _classApplyDescriptorSet(receiver, descriptor, value); return value; }
function _classExtractFieldDescriptor(receiver, privateMap, action) { if (!privateMap.has(receiver)) { throw new TypeError("attempted to " + action + " private field on non-instance"); } return privateMap.get(receiver); }
function _classApplyDescriptorSet(receiver, descriptor, value) { if (descriptor.set) { descriptor.set.call(receiver, value); } else { if (!descriptor.writable) { throw new TypeError("attempted to set read only private field"); } descriptor.value = value; } }
import { Framework } from "./core";
(function (f, _xhr, _default_args, _url, _type, _data, _callbacks, _load) {
  f.ajax = (_xhr = /*#__PURE__*/new WeakMap(), _default_args = /*#__PURE__*/new WeakMap(), _url = /*#__PURE__*/new WeakMap(), _type = /*#__PURE__*/new WeakMap(), _data = /*#__PURE__*/new WeakMap(), _callbacks = /*#__PURE__*/new WeakMap(), _load = /*#__PURE__*/new WeakSet(), /*#__PURE__*/function () {
    function _class(args) {
      _classCallCheck(this, _class);
      _classPrivateMethodInitSpec(this, _load);
      _classPrivateFieldInitSpec(this, _xhr, {
        writable: true,
        value: null
      });
      _classPrivateFieldInitSpec(this, _default_args, {
        writable: true,
        value: {
          "url": "",
          "type": "get",
          "data": {},
          "success": null,
          "error": null
        }
      });
      _classPrivateFieldInitSpec(this, _url, {
        writable: true,
        value: ""
      });
      _classPrivateFieldInitSpec(this, _type, {
        writable: true,
        value: ""
      });
      _classPrivateFieldInitSpec(this, _data, {
        writable: true,
        value: {}
      });
      _classPrivateFieldInitSpec(this, _callbacks, {
        writable: true,
        value: []
      });
      _classPrivateFieldSet(this, _xhr, new XMLHttpRequest());
    }
    _createClass(_class, [{
      key: "done",
      value: function done(callback) {
        if (typeof callback === "function") {
          _classPrivateFieldGet(this, _callbacks).push({
            "callback_success": callback
          });
        }
        return this;
      }
    }, {
      key: "success",
      value: function success(callback) {
        return this.done(callback);
      }
    }, {
      key: "fail",
      value: function fail(callback) {
        if (typeof callback === "function") {
          _classPrivateFieldGet(this, _callbacks).push({
            "callback_error": callback
          });
        }
        return this;
      }
    }, {
      key: "error",
      value: function error(callback) {
        return this.fail(callback);
      }
    }, {
      key: "always",
      value: function always(callback) {
        if (typeof callback === "function") {
          _classPrivateFieldGet(this, _callbacks).push({
            "callback_complete": callback
          });
        }
        return this;
      }
    }, {
      key: "complete",
      value: function complete(callback) {
        return this.always(callback);
      }
    }, {
      key: "progress",
      value: function progress(callback) {
        if (typeof callback === "function") {
          _classPrivateFieldGet(this, _callbacks).push({
            "callback_progress": callback
          });
        }
        return this;
      }
    }, {
      key: "then",
      value: function then(successCallback) {
        var errorCallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        if (typeof callback_success === "function") {
          if (typeof errorCallback === "function") {
            _classPrivateFieldGet(this, _callbacks).push({
              "callback_success": successCallback,
              "callback_error": errorCallback
            });
          } else {
            _classPrivateFieldGet(this, _callbacks).push({
              "callback_success": callback_success
            });
          }
        }
        return this;
      }
    }, {
      key: "abort",
      value: function abort() {
        _classPrivateFieldGet(this, _xhr).abort();
        return this;
      }
    }]);
    return _class;
  }());
  function _load2() {
    var _this = this;
    _classPrivateFieldGet(this, _xhr).onerror = function (error) {
      _classPrivateFieldGet(_this, _callbacks).forEach(function (data) {
        if (data.callback_error !== undefined) {
          data.callback_error(_classPrivateFieldGet(_this, _xhr), _classPrivateFieldGet(_this, _xhr).statusText, error);
        }
      });
      _classPrivateFieldGet(_this, _callbacks).forEach(function (data) {
        if (data.callback_complete !== undefined) {
          data.callback_complete({}, _classPrivateFieldGet(_this, _xhr), _classPrivateFieldGet(_this, _xhr).statusText, error);
        }
      });
    };
    _classPrivateFieldGet(this, _xhr).addEventListener("progress", function (evt) {
      _classPrivateFieldGet(_this, _callbacks).forEach(function (data) {
        if (data.callback_progress !== undefined) {
          data.callback_progress(evt, _classPrivateFieldGet(_this, _xhr));
        }
      });
    });
    _classPrivateFieldGet(this, _xhr).addEventListener("load", function (evt) {
      var response = {};
      if (_classPrivateFieldGet(_this, _xhr).readyState == 4) {
        try {
          response = JSON.parse(_this.responseText);
        } catch (error) {
          response = _this.responseText;
        }
        _classPrivateFieldGet(_this, _callbacks).forEach(function (data) {
          if (data.callback_success !== undefined) {
            data.callback_success(response, _classPrivateFieldGet(_this, _xhr), _classPrivateFieldGet(_this, _xhr).statusText, _classPrivateFieldGet(_this, _xhr).status);
          }
        });
        _classPrivateFieldGet(_this, _callbacks).forEach(function (data) {
          if (data.callback_complete !== undefined) {
            data.callback_complete(response, _classPrivateFieldGet(_this, _xhr), _classPrivateFieldGet(_this, _xhr).statusText, _classPrivateFieldGet(_this, _xhr).status);
          }
        });
      } else {
        _classPrivateFieldGet(_this, _callbacks).forEach(function (data) {
          if (data.callback_error !== undefined) {
            data.callback_error(_classPrivateFieldGet(_this, _xhr), _classPrivateFieldGet(_this, _xhr).statusText, _this.status);
          }
        });
        _classPrivateFieldGet(_this, _callbacks).forEach(function (data) {
          if (data.callback_complete !== undefined) {
            data.callback_complete({}, _classPrivateFieldGet(_this, _xhr), _classPrivateFieldGet(_this, _xhr).statusText, _this.status);
          }
        });
      }
    });
  }
  f.ajax = function (args) {
    /*
    	jqXHR.done(function( data, textStatus, jqXHR ){});
    			jqXHR.fail(function( jqXHR, textStatus, errorThrown ){});
    	
    	jqXHR.always(function( data|jqXHR, textStatus, jqXHR|errorThrown){});
    			jqXHR.then(function( data, textStatus, jqXHR ) {}, function( jqXHR, textStatus, errorThrown ){});
    .
     */
    xhttp.onload = function () {
      var response;
      if (this.readyState == 4 && this.status == 200) {
        var _response = "";
        try {
          //check if the response in json 
          //if json the parse it
          _response = JSON.parse(this.responseText);
        } catch (e) {
          //if not json the simple reurn the response
          _response = this.responseText;
        }
        // give a success callback
        return success(_response);
      } else {
        //give a fail callback with the error status 
        return fail(this.status);
      }
    };
    var parameters = "";
    if (args) {
      type = args["type"];
      if ('data' in args) {
        //converting object to url URLSearchParams
        parameters = new URLSearchParams(args['data']).toString();
      }
    }
    if (type && type.toUpperCase() == 'POST') {
      xhttp.open("POST", url, true);
      xhttp.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
      xhttp.send(parameters);
    } else if (!type || type.toUpperCase() == 'GET') {
      xhttp.open("GET", url + "?" + parameters, true);
      xhttp.setRequestHeader("X-Requested-With", "XMLHttpRequest");
      xhttp.send();
    }
  };
})(Framework);